
import { formatFloat, propsInstance, gettersInstance } from "@/lib/util";
import { Farm } from "@/lib/types/Farm";
import { Component, MixedVue, mixins } from "@/vue";

interface FarmInfoProps {
  farm: Farm;
  showExpand?: boolean;
}

const Props = propsInstance<FarmInfoProps>({
  farm: {
    type: Object,
    required: true,
  },
  showExpand: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const StoreGetters = gettersInstance(["currentFarmId", "currentSeason"]);

@Component({
  name: "FarmInfo",
})
export default class FarmInfo extends mixins(MixedVue, Props, StoreGetters) {
  get displayParcelCount(): number {
    if (this.farm.id === this.currentFarmId && this.currentSeason) {
      return this.currentSeason.parcels_count;
    }
    return this.farm.parcel_count;
  }

  get displayHectares(): number {
    if (this.farm.id === this.currentFarmId && this.currentSeason) {
      return this.currentSeason.hectares;
    }
    return this.farm.hectares;
  }
}
